import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import axios from "axios"
import { Loader, Dimmer } from "semantic-ui-react"
import getStorageUser from "../middlewares/GetStorageUser"
import { ObjNotificaciones } from "../config/notificaciones";

const ignoredRoutes: string[] = [
    '/',
    '/login',
    '/usuario/registrarUsuario'
]

const ValidateAccessMiddleware = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState<any>(false)

    const validateAccess = async () => {
        setLoading(true)

        const token = localStorage.getItem('token')
        const user = getStorageUser()

        if(!token){
            localStorage.clear();
        }

        const validateToken = await axios.get(`${process.env.REACT_APP_SERVER_USERS}users/token/${token}`);

        if (validateToken?.data?.status !== 200) {
            navigate('/login');
            ObjNotificaciones.MSG_ERROR('warning', 'Sesión expirada', 'Tú sesión ha expirado, intenta iniciar sesión nuevamente');
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }

        if (!user && validateToken?.data?.user?.id !== user?.id) {
            ObjNotificaciones.MSG_ERROR('warning', 'Sesión expirada', 'Tú sesión ha expirado, intenta iniciar sesión nuevamente');
            return navigate('/login')
        }

        if (location?.pathname?.indexOf('/administrador') !== -1) {
            if (location?.pathname !== '/administrador' && user?.role_id !== 1) {
                if (!user?.permissions?.some(permiso => permiso?.permission?.route[0]?.route === location?.pathname)) {
                    // Redirigir al usuario a la página de administrador
                    return navigate('/administrador');
                }
            }
        }

        setLoading(false)
    }

    const checkRoutes = () => {
        if (ignoredRoutes.find((route: any) => route == location.pathname)) {
            return false
        }

        return true
    }

    useEffect(() => {
        if (checkRoutes()) {
            validateAccess()
        }
    }, [location])

    return (
        <>
            {
                location?.pathname !== "/usuario/registrarUsuario" &&
                    <Dimmer active={loading} inverted>
                        <Loader size="massive" inverted />
                    </Dimmer>
            }
        </>
    )
}

export default ValidateAccessMiddleware